import { z } from "zod";
// Ordered for default display grouping. "other" is the catch-all and MUST be last.
export const SHOPPING_CATEGORIES = [
    "produce",
    "meat-seafood",
    "dairy-eggs",
    "bakery",
    "pantry",
    "frozen",
    "beverages",
    "household",
    "other",
];
export const ShoppingCategorySchema = z.enum(SHOPPING_CATEGORIES);
export const DEFAULT_CATEGORY = "other";
//# sourceMappingURL=categories.js.map